import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
import { jwtDecode } from "jwt-decode"
import { icon } from "leaflet";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getIncidencias = async (setData, setLoading, fecha_inicio, fecha_fin, exeso_vel, cancela_servicio, no_requiere_serv, setDetalleChatGPT, cliente) => {

    await api.get(`${apiUrl}/monitor/incidencias?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&exeso_vel=${exeso_vel}&cancela_servicio=${cancela_servicio}&no_requiere_serv=${no_requiere_serv}&id_cliente=${cliente ? cliente.code : null}`).then((res) => {

        const proveedores = Array.from(new Set(res.data.selectProveedor.map(record => record.name)));
        let _res = { ...res }
        _res.data.selectProveedor = proveedores
        // getDetalle

        let detalleString = ""
        _res.data.data.map((item, key) => {

            if (key == 0) {
                detalleString = detalleString + item.DETALLE
            }
            else {
                detalleString = detalleString + ", " + item.DETALLE
            }
        })


        setDetalleChatGPT(detalleString)
        setData(_res.data)
        setLoading(false)
    })
        .catch((error) => {
            console.log("getIncidencias", error);

        })
}
export const actualizarValidacionVisualizacion = async (params) => {
  

    await api.patch(`${apiUrl}/monitor/incidencias/updateVisibilidad`, params)
        .then((res) => {
          

            if (res.data.status == 200) {


            }
            else {
                Swal.fire({
                    text: res.data.message,
                    icon: "error"
                })
            }

        })
        .catch((error) => {

            console.log("getIncidencias", error);

        })
}

export const chatGPTApiPost = (detalle, setRespuesta, setvisibleIA) => {
    const token = sessionStorage.getItem("token")
    const tokenDecode = jwtDecode(token)

    const params = {
        "Mensaje": detalle,
        "Contexto": 2,
        "Iniciar": true
    }
    Swal.fire({
        title: 'Cargando...',
        text: 'procesando',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    });
    api.post(`https://api-ia.sumaenlinea.mx/api/ChatGPT/enviar?usuario=${tokenDecode.ID}`, params)
        .then((res) => {
            setRespuesta(res.data.respuestaChatGPT)
            Swal.close();
            setvisibleIA(true)
        })
        .catch((error) => {
            console.log("error", error);

            Swal.close();
        })
}
export const addTaxi = async (params) => {

    Swal.fire({
        title: 'Cargando...',
        text: 'procesando',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    });
    await api.post(`${apiUrl}/monitor/incidencias/add-taxi`, params)
        .then((res) => {
            Swal.close();
        })
        .catch((error) => {
            console.log("error", error);
            Swal.close();
        })
}
export const getTaxi = async (id_incidente, setItems) => {


    await api.get(`${apiUrl}/monitor/incidencias/get-taxi?id_incidente=${id_incidente}`)
        .then((res) => {
            setItems(res.data)
        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const delTaxi = async (id_taxi) => {

    await api.delete(`${apiUrl}/monitor/incidencias/del-taxi?id_taxi=${id_taxi}`)
        .then((res) => {
        })
        .catch((error) => {
            console.log("error", error);
        })
}
export const updateTaxi = (params) => {
    
  
    
    api.patch(`${apiUrl}/monitor/incidencias/edit-taxi`,params)
        .then((res) => {
            Swal.fire({
                icon:"success",
                title:`Se actualizo : ${params.id_reembolso}`
            })
        })
        .catch((error) => {
            console.log("error", error);
        })
}